import React from 'react';
import { Route, Switch } from 'react-router-dom';
import Home from './pages/Home';
import Overview from './pages/Overview';
import Sales from './pages/Sales';
import Demand from './pages/Demand';
import PurchaseGuide from './pages/PurchaseGuide';
import Supplier from './pages/Supplier';
import Warehouse from './pages/Warehouse';
import Production from './pages/Production';
import Product from './pages/Product';
import Finance from './pages/Finance';
import Status from './pages/Status';
import QA from './pages/QA';
export default function HelpCenter() {
  return /*#__PURE__*/React.createElement(Switch, null, /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: "/help",
    component: Home
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/help/overview",
    component: Overview
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/help/sales",
    component: Sales
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/help/demand",
    component: Demand
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/help/purchase",
    component: PurchaseGuide
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/help/supplier",
    component: Supplier
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/help/warehouse",
    component: Warehouse
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/help/production",
    component: Production
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/help/product",
    component: Product
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/help/finance",
    component: Finance
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/help/status",
    component: Status
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/help/qa",
    component: QA
  }));
}